/**
 * Checks if the tenant is a release flag environment, the below tenants cover DEV, QA, and Gecko as per QA request.
 * @param tenant
 */
export const isReleaseFlagEnvironment = (tenant: string) => ['eng', 'gko'].includes(tenant);
